import React from 'react';

interface EditPencilIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const EditPencilIcon: React.FC<EditPencilIconProps> = ({ 
  width = 12, 
  height = 12, 
  color = '#989898' 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 12 12" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M8.33594 0.59513C8.55008 0.525574 8.78064 0.525589 8.99479 0.59513C9.14093 0.642615 9.25827 0.724552 9.36198 0.812578C9.46208 0.897559 9.57381 1.01009 9.70052 1.1368L10.8607 2.2963C10.988 2.42363 11.101 2.53576 11.1862 2.63615C11.2744 2.7401 11.3561 2.85764 11.4036 3.00398C11.4732 3.21814 11.4732 3.44872 11.4036 3.66284C11.3561 3.8091 11.2744 3.92681 11.1862 4.03068C11.1011 4.1309 10.9884 4.24282 10.8613 4.36987L4.29753 10.9337H11.332C11.5529 10.9337 11.7317 11.1125 11.7318 11.3334C11.7318 11.5543 11.5529 11.7338 11.332 11.7338H0.665365C0.444451 11.7338 0.265625 11.5543 0.265625 11.3334V8.66675C0.265645 8.56069 0.307816 8.45919 0.382812 8.38419L7.63021 1.13615C7.75682 1.00953 7.86875 0.897467 7.96875 0.812578C8.07253 0.72448 8.18972 0.642638 8.33594 0.59513ZM1.0651 8.83276V10.9337H3.16667L8.09961 6.00008L5.9987 3.89917L1.0651 8.83276ZM8.74805 1.35555C8.69449 1.33814 8.63624 1.33814 8.58268 1.35555C8.57655 1.35756 8.55158 1.36722 8.48633 1.4226C8.41687 1.48158 8.33139 1.56647 8.19531 1.70255L6.5638 3.33341L8.66471 5.43432L10.2949 3.80477C10.4314 3.66828 10.5171 3.58203 10.5762 3.51245C10.6314 3.44735 10.6405 3.42234 10.6426 3.41609C10.66 3.36256 10.6599 3.30487 10.6426 3.25138C10.6407 3.24551 10.6322 3.22039 10.5762 3.15438C10.517 3.08468 10.4316 2.99873 10.2949 2.86206L9.13476 1.7019C8.99883 1.56597 8.91376 1.48083 8.8444 1.42195C8.77905 1.36649 8.75402 1.3575 8.74805 1.35555Z" 
        fill={color}
      />
    </svg>
  );
};

export default EditPencilIcon;
